function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const XCircleIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.354 0 0 5.354 0 12s5.354 12 12 12 12-5.354 12-12S18.646 0 12 0zm0 21.23c-5.077 0-9.23-4.153-9.23-9.23 0-5.077 4.153-9.23 9.23-9.23 5.077 0 9.23 4.153 9.23 9.23 0 5.077-4.153 9.23-9.23 9.23zM10.06 7.94a1.5 1.5 0 0 0-2.12 2.12l2.189 2.19-2.19 2.19a1.5 1.5 0 0 0 2.122 2.12l2.189-2.189 2.19 2.19a1.5 1.5 0 0 0 2.12-2.122l-2.189-2.189 2.19-2.19a1.5 1.5 0 0 0-2.122-2.12l-2.189 2.189-2.19-2.19z"
  }));
};
export default XCircleIcon;